import useAuth from '../../../../auth/useAuth';

import { roundNames, teamNamesColors } from '../data';
import RoundStatusToggle from './roundStatusToggle';
import RoundStatus from './roundStatus';

import Team from './team';
import UserPoints from './userPoints';

import './styles.css';

export default function Header ({ 
  roundCount,
  currentRound,
  rounds,
  teams,
  onRoundStatusChange,
  onUpdateButtonClick,
  isUpdateScoresButtonLoading,
  onNextRoundButtonClick,
  userScores
}) {
  const { isInstructor, isStudent, getUser } = useAuth();

  const user = getUser();
  const userTeam = isStudent() ? teams.find(team => team.user_ids.includes(user.id)) : null;
  const userTeamColor = teamNamesColors.find(teamNameColor => teamNameColor.name === userTeam?.name)?.color;

  const isRoundActive = rounds[currentRound - 1]?.is_active || false;

  const offset = roundNames.length - roundCount;
  const roundIndex = offset + (currentRound - 1);

  const isLastRound = currentRound === roundCount;

  return (
    <div className="review-session-header">
      { isStudent() && userTeam &&
        <Team
          name={userTeam.name}
          color={userTeamColor}
        />
      }
      <div className="review-session-round">
        <div className="review-session-round-status" data-tour-id="round-toggle">
          <span className="round-name">{roundNames[roundIndex]} Round</span>
          {
            isInstructor()
              ? <RoundStatusToggle isActive={isRoundActive} onChange={onRoundStatusChange} />
              : <RoundStatus isActive={isRoundActive}/>
          }
        </div>
        <div className="review-session-round-management" data-tour-id="round-management">
          <button
            className={`button button-submit review-session-update-scores${isUpdateScoresButtonLoading ? ' loading' : ''}`}
            data-tour-id="update-scores-button"
            onClick={onUpdateButtonClick}
          >
            {isUpdateScoresButtonLoading ? '' : 'Update Scores'}
          </button>
          <button
            className="button review-session-next-round"
            data-tour-id="next-round-button"
            onClick={onNextRoundButtonClick}
          >
            {isLastRound ? 'Process Final Results' : 'Next round'}
          </button>
        </div>
      </div>
      { isStudent() && userTeam &&
        <UserPoints
          score={userScores}
        />
      }
    </div>
  );
};